document.addEventListener("DOMContentLoaded", () => {

  function enableCarouselAutoPlay() {

    const productSlider = document.querySelector(
      ".hdt-collection-products"
    );

    if (!productSlider) return false;

    // slider engine exists?
    if (!productSlider.HDT_SLIDER) return false;

    // update internal settings
    productSlider.HDT_SLIDER.flickity.options.autoPlay = 2500;
    productSlider.HDT_SLIDER.flickity.options.wrapAround = true;
    productSlider.HDT_SLIDER.flickity.options.pauseAutoPlayOnHover = false;

    // restart autoplay
    productSlider.HDT_SLIDER.flickity.stopPlayer();
    productSlider.HDT_SLIDER.flickity.startPlayer();

    return true;
  }

  // Wait until the slider engine loads
  let watch = setInterval(() => {
    if (enableCarouselAutoPlay()) {
      clearInterval(watch);
    }
  }, 500);

});
